import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreateRadiologyPrescriptionMutation as useChCreateRadiologyPrescriptionMutationType } from "@/modules/patients/detail/meas-radiology-prescription/ch/services/__generated__/useChCreateRadiologyPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChCreateRadiologyPrescriptionMutation($input: Ch_createMeasRadiologyPrescriptionInput!) {
    ch_createMeasRadiologyPrescription(input: $input) {
      ch_MeasRadiologyPrescription {
        id
        ...chMeasRadiologyPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreateRadiologyPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreateRadiologyPrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreateRadiologyPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateRadiologyPrescriptionMutation }
